const types = [{
    id: 'text',
    title: '文本'
},
{
    id: 'number',
    title: '数字'
},
{
    id: 'select',
    title: '下拉框'
},
{
    id: 'checkbox',
    title: '多选框'
},
{
    id: 'radio',
    title: '单选框'
},
{
    id: 'date',
    title: '日期'
},
{
    id: 'datetime',
    title: '日期时间'
},
{
    id: 'range',
    title: '区间'
},];

const getCfgItems = (content) => {
    if (content == '') return [];
    return content.split('|');
}

const getItemLabel = (value) => {
    if (value == '') return '';
    let arr = value.split(':');
    return arr[1];
}

const getItemValue = (value) => {
    if (value == '') return '';
    let arr = value.split(':');
    return arr[0];
}
const getRuleLabel = (v, f, rules) => {
    let rule = rules.find(ele => ele.field == f);
    if (!rule) return '';
    let title = '';
    if (["select", "checkbox", "radio"].includes(rule.type)) {
        let items = rule.content.split("|");
        items.forEach(ele => {
            let options = ele.split(':');
            if (options[0] == v) {
                title = options[1];
            }
        });
    } else {
        title = v;
    }

    return title;
}

export default {
    types,
    getCfgItems,
    getItemLabel,
    getItemValue,
    getRuleLabel
}